export const pdfToolFaqItems = [
  {
    question: '文件会上传服务器吗？',
    answer: 'PDF 文件类工具优先在浏览器本地处理，除非工具页明确说明需要服务器。'
  },
  {
    question: '为什么加密 PDF 处理失败？',
    answer: '浏览器端库无法处理部分加密、受保护或损坏文件，需要先解除限制或使用未加密文件。'
  },
  {
    question: '为什么 PDF 压缩后没变小？',
    answer: '当前压缩主要是重新保存和优化对象结构，不会强制降低图片质量或裁剪字体。'
  },
  {
    question: '为什么 PDF 提取文字为空？',
    answer: '扫描件或图片型 PDF 没有文本层，需要 OCR；本版本不做 OCR。'
  },
  {
    question: '手机可以使用吗？',
    answer: '可以尝试使用，但大文件更适合电脑浏览器处理。'
  }
]

const PdfToolFaq = () => {
  return (
    <section className="mx-auto mt-6 max-w-4xl rounded-lg border border-slate-200 bg-white p-5">
      <h2 className="text-lg font-semibold text-slate-950">常见问题</h2>
      <div className="mt-4 space-y-4">
        {pdfToolFaqItems.map(item => (
          <div key={item.question}>
            <h3 className="text-sm font-semibold text-slate-800">{item.question}</h3>
            <p className="mt-1 text-sm leading-6 text-slate-600">{item.answer}</p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default PdfToolFaq
